<template>
  <div class="conpany">
    <div class="title">Company Introduction</div>
    <div class="flex_con">
      <div class="flex_left">
        <img src="../assets/company_pic.png" alt="">
      </div>
      <div class="flex_right">
        <div class="item">
          <div class="item_icon">
            <img src="../assets/company1.png" alt="">
          </div>
          <div class="item_con">
            <div class="item_title">Cash credit services</div>
            <div class="item_text">Zada Cash is a safe and reliable app designed to provide fast cash credit services to individuals in need in the Philippines.  </div>
          </div>
        </div>
        <div class="item">
          <div class="item_icon">
            <img src="../assets/company2.png" alt="">
          </div>
          <div class="item_con">
            <div class="item_title">Quick approval</div>
            <div class="item_text">We aim to offer a wide range of products to meet your various needs, helping you solve financial problems immediately when you need funds.  </div>
          </div>
        </div>
        <div class="item">
          <div class="item_icon">
            <img src="../assets/company3.png" alt="">
          </div>
          <div class="item_con">
            <div class="item_title">Simple steps</div>
            <div class="item_text">Our customers can now enjoy our services through a simple application process. We only require 1 ID and basic personal information to apply for a loan, with fast approval and no collateral needed. </div>
          </div>
        </div>
        <div class="item">
          <div class="item_icon">
            <img src="../assets/company4.png" alt="">
          </div>
          <div class="item_con">
            <div class="item_title">Safe and Reliable</div>
            <div class="item_text">We ensure that all transactions with us are safe and reliable, as we strictly adhere to the confidentiality of our customers' personal data. We follow the "Principle of Minimum Necessity" and seek your explicit consent. We do not share any sensitive personal information with third parties.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.conpany {
  background-color: #EFF1F4;
  width: 100%;
  padding: 119px 206px 137px 176px;
  box-sizing: border-box;
  margin-top: 223px;
  .title {
    text-align: center;
    width: 100%;
    font-family: 'Lexend_Medium';
    font-weight: 500;
    font-size: 61px;
    color: #000000;
    line-height: 81px;
  }
  .flex_con {
    display: flex;
    justify-content: space-between;
    margin-top: 61px;
    .flex_left {
      width: 668px;
      height: 850px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .flex_right {
      width: 590px;
      .item {
        position: relative;
        display: flex;
        margin-bottom: 25px;
        padding: 25px 28px 27px 17px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 24px;
        width: 100%;
        box-shadow: 0px 4px 15px 0px rgba(57, 73, 77, 0.16);
        .item_icon {
          width: 108px;
          height: 108px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_con {
          margin-left: 20px;
          .item_title {
            font-family: 'Lexend_Regular';
            font-weight: 500;
            font-size: 26px;
            color: #000000;
            line-height: 31px;
          }
          .item_text {
            margin-top: 18px;
            font-family: 'Lexend_Light';
            font-weight: 300;
            font-size: 17px;
            color: #000000;
            line-height: 23px;
          }
        }
      }
      .item:hover {
        box-shadow: 2px 2px 30px 0px rgba(31, 29, 13, 0.09);
        transform: scale(1.05);
        transition: all 0.3s ease;
      }
      .item:nth-of-type(2) {
        left: -120px;
        .item_icon {
          width: 119px;
          height: 119px;
        }
      }
      .item:nth-of-type(3) {
        left: -170px;
        .item_icon {
          width: 98px;
          height: 98px;
        }
      }
      .item:nth-of-type(4) {
        .item_icon {
          width: 96px;
          height: 96px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company.vue